module.exports = __webpack_public_path__ + "img/UTSTEI.2eb67f3c.png";